import { create } from "zustand";

interface newPartner {
    name: string;
    address: string;
    socialReason: string;
    isSubscriptionEnabled: boolean;
    startDate: Date | null;
    discountAmount: number;
    idSubscription: number;
    discountExpirationDate: Date | null;
}

export type SuperAdminCreatePartnerStore = {
    name: string;
    setName: (name: string) => void;

    adress: string;
    setAdress: (adress: string) => void;

    socialReason: string;
    setSocialReason: (socialReason: string) => void;

    isSubscriptionEnabled: boolean;
    setIsSubscriptionEnabled: (isSubscriptionEnabled: boolean) => void;

    startDate: Date | null;
    setStartDate: (startDate: Date | null) => void;

    discountAmount: number;
    setDiscountAmount: (discountAmount: number) => void;

    discountExpirationDate: Date | null;
    setDiscountExpirationDate: (discountExpirationDate: Date | null) => void;

    isSubscription: any[];
    setIsSubscription: (isSubscription: any) => void;

    selectedSubscription: number;
    setSelectedSubscription: (selectedSubscription: number) => void;

    openDetails: boolean | null;
    setOpenDetails: (openDetails: boolean) => void;

    reset: () => void;

    invoices: any;
    setInvoices: (invoices: any) => void;

    displayDiv: boolean;
    setDisplayDiv: (displayDiv: boolean) => void;

    animationClass: string;
    setAnimationClass: (animationClass: string) => void;

    partnerData: newPartner;
    setPartnerData: (property: keyof newPartner, value: any) => void;

    files: any;
    setFiles: (files: any) => void;
}


export const useSuperAdminCreatePartnerStore = create<SuperAdminCreatePartnerStore>((set) => ({
    name: "",
    setName: (name: string) => set({ name }),

    adress: "",
    setAdress: (adress: string) => set({ adress }),

    socialReason: "",
    setSocialReason: (socialReason: string) => set({ socialReason }),

    isSubscriptionEnabled: false,
    setIsSubscriptionEnabled: (isSubscriptionEnabled: boolean) => set({ isSubscriptionEnabled }),

    startDate: null,
    setStartDate: (startDate: Date | null) => set({ startDate }),

    discountAmount: 0,
    setDiscountAmount: (discountAmount: number) => set({ discountAmount }),

    discountExpirationDate: null,
    setDiscountExpirationDate: (discountExpirationDate: Date | null) => set({ discountExpirationDate }),

    isSubscription: [],
    setIsSubscription: (isSubscription: any) => set({ isSubscription }),

    selectedSubscription: 0,
    setSelectedSubscription: (selectedSubscription: any) => set({ selectedSubscription }),
    
    openDetails: null,
    setOpenDetails: (openDetails: boolean | null) => set({ openDetails }),

    reset: () => set({
        name: "",
        adress: "",
        socialReason: "",
        isSubscriptionEnabled: false,
        startDate: null,
        discountAmount: 0,
        discountExpirationDate: null,
        isSubscription: [],
        selectedSubscription: 0,
        partnerData: {
            name: "",
            address: "",
            socialReason: "",
            isSubscriptionEnabled: false,
            startDate: null,
            discountAmount: 0,
            idSubscription: 0,
            discountExpirationDate: null,
        },
    }),

    invoices: [],
    setInvoices: (invoices: any) => set({ invoices }),

    displayDiv: false,
    setDisplayDiv: (displayDiv: boolean) => set({ displayDiv }),

    animationClass: "",
    setAnimationClass: (animationClass: string) => set({ animationClass }),

    partnerData: {
        name: "",
        address: "",
        socialReason: "",
        isSubscriptionEnabled: false,
        startDate: null,
        discountAmount: 0,
        discountExpirationDate: null,
        idSubscription: 0,
    },
    setPartnerData: (property, value) => set((state) => ({ partnerData: { ...state.partnerData, [property]: value } })),

    files: [],
    setFiles: (files: any) => set({ files}),
}));